





























import { ModalMixin, Modal, notify } from 'mycorems-app-shared';
import AsyncBtn from '../components/AsyncBtn.vue';
import { changePassword } from './password-recovery';

interface Data {
  currentPassword: string|null,
  newPassword: string|null,
  task: Promise<void>|null,
}

export default ModalMixin.extend({
  components: {
    Modal,
    AsyncBtn,
  },
  props: {
    userId: {
      type: String,
      required: true,
    },
  },
  data(): Data {
    return {
      currentPassword: null,
      newPassword: null,
      task: null,
    };
  },
  computed: {
    canUpdate(): boolean {
      return (this.currentPassword !== null && this.newPassword !== null);
    },
  },
  methods: {
    updatePassword(): void {
      if (!this.currentPassword) return;
      if (!this.newPassword) return;
      this.task = changePassword(this.userId, this.currentPassword, this.newPassword);
      this.task.then(() => {
        notify.success('Password has been changed.');
        this.$emit('ok');
        this.hide();
      });
    },
  },
});
